import React, { useMemo } from 'react';
import { Alert, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OpenItemsCompaniesTriage } from '@viilutalous/dashboard';
import { useTenant } from '../contexts/TenantContext';
import { useMeHost } from '../contexts/MeHostContext';

/**
 * /me/all-companies — accountant triage across the selected host's tenants.
 * Double-click switches tenant and opens that company's Tilitoimisto overview.
 */
export default function MeAllCompanies() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { tenants, selectTenant } = useTenant();
  const { hostId, hosts } = useMeHost();

  const scopedTenants = useMemo(() => {
    if (hosts.length > 0) {
      if (!hostId) return [];
      return tenants.filter((tnt) => (tnt.host_id || tnt.hostId) === hostId);
    }
    return tenants;
  }, [tenants, hostId, hosts.length]);

  if (hosts.length === 0 && tenants.length === 0) {
    return <Alert severity="info">{t('me.companies.empty', 'You have no tenant access yet.')}</Alert>;
  }

  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      <OpenItemsCompaniesTriage
        tenants={scopedTenants}
        selectTenant={selectTenant}
        crossTenant
        hostId={hostId}
        onOpenTenant={(tenant) => {
          if (!tenant?.slug) return;
          selectTenant(tenant);
          navigate(`/app/${tenant.slug}/open-items`);
        }}
        onOpenInvoice={(tenant, path) => {
          if (!tenant?.slug) return;
          selectTenant(tenant);
          navigate(`/app/${tenant.slug}${path}`);
        }}
      />
    </Box>
  );
}
